import { Component, Input } from "@angular/core";
import { UserService, WorkspaceService } from '@mypxplat/xplat/core';

import { CreatePublicLinkBaseComponent } from '@mypxplat/xplat/features';
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";

@Component({
  selector: "myp-create-public-link",
  templateUrl: "create-public-link.component.html",
})
export class CreatePublicLinkComponent extends CreatePublicLinkBaseComponent {
  @Input() file: any;
  public show_comments = true;
  public expiration_date;
  public loading: boolean = false;

  constructor(userService: UserService, public activeModal: NgbActiveModal, public workspaceService: WorkspaceService) {
    super(userService);
  }

  toggleShowComments() {
    this.show_comments = !this.show_comments;
  }

  submit() {
    let args = {
      file_id: this.file.id,
      show_comments: this.show_comments,
    };
    this.loading = true;
    this.workspaceService.createPublicLink(args).subscribe((result: any) => {
      this.loading = false;
      this.activeModal.close(result.link);
    });
  }
}
